(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    class ProductDescriptionTruncation extends HTMLElement {
    constructor() {
      super();
      
      // Look for elements in the wrapped content
      this.content = this.querySelector('.product-description-content');
      this.toggle = this.querySelector('.product-description-toggle');
      this.readMoreText = this.querySelector('.read-more-text');
      this.readLessText = this.querySelector('.read-less-text');
      
      // If not found in wrapper, look in the original element
      if (!this.content || !this.toggle) {
        const originalElement = this.querySelector('.product-description-truncated');
        if (originalElement) {
          this.content = originalElement.querySelector('.product-description-content');
          this.toggle = originalElement.querySelector('.product-description-toggle');
          this.readMoreText = originalElement.querySelector('.read-more-text');
          this.readLessText = originalElement.querySelector('.read-less-text');
        }
      }
      
      this.truncateLines = parseInt(this.dataset.truncateLines) || 3;
      this.isExpanded = false;
      
      this.init();
    }
    
    init() {
      if (!this.content || !this.toggle) {
        return;
      }
      
      // Wait for content to be fully rendered
      requestAnimationFrame(() => {
        this.checkTruncation();
        this.toggle.addEventListener('click', this.toggleContent.bind(this));
      });
    }
    
    checkTruncation() {
      const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
      const maxHeight = lineHeight * this.truncateLines;
      const contentHeight = this.content.scrollHeight;
      
      if (contentHeight > maxHeight) {
        this.content.classList.add('truncated');
        this.content.style.setProperty('--truncate-lines', this.truncateLines);
        this.toggle.style.display = 'inline-block';
      } else {
        this.toggle.style.display = 'none';
      }
    }
    
    toggleContent() {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.content.classList.remove('truncated');
        this.readMoreText.style.display = 'none';
        this.readLessText.style.display = 'inline';
        this.toggle.setAttribute('aria-expanded', 'true');
      } else {
        this.content.classList.add('truncated');
        this.readMoreText.style.display = 'inline';
        this.readLessText.style.display = 'none';
        this.toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
  
  if (!customElements.get('product-description-truncation')) {
    customElements.define('product-description-truncation', ProductDescriptionTruncation);
  }
  
  // Initialize existing elements
  function initializeTruncation() {
    const elements = document.querySelectorAll('.product-description-truncated');
    
    elements.forEach((element, index) => {
      
      // Initialize truncation directly on the element
      const content = element.querySelector('.product-description-content');
      const toggle = element.querySelector('.product-description-toggle');
      const readMoreText = element.querySelector('.read-more-text');
      const readLessText = element.querySelector('.read-less-text');
      const truncateLines = parseInt(element.dataset.truncateLines) || 3;
      
      if (content && toggle) {
        // Add truncation functionality directly
        addTruncationToElement(element, content, toggle, readMoreText, readLessText, truncateLines);
      }
    });
  }
  
  function addTruncationToElement(element, content, toggle, readMoreText, readLessText, truncateLines) {
    let isExpanded = false;
    
    function checkTruncation() {
      // First, remove truncated class to get full height
      content.classList.remove('truncated');
      const fullHeight = content.scrollHeight;
      
      // Calculate target height for truncation
      const lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 1.5;
      const targetHeight = lineHeight * truncateLines;
      
      if (fullHeight > targetHeight) {
        content.classList.add('truncated');
        content.style.setProperty('--truncate-lines', truncateLines);
        content.style.setProperty('--target-height', targetHeight + 'px');
        toggle.style.display = 'inline';
      } else {
        toggle.style.display = 'none';
      }
    }
    
    function toggleContent() {
      isExpanded = !isExpanded;
      
      if (isExpanded) {
        // Remove truncated class to expand
        content.classList.remove('truncated');
        
        // Smooth transition for text change
        if (readMoreText && readLessText) {
          readMoreText.style.opacity = '0';
          setTimeout(() => {
            readMoreText.style.display = 'none';
            readLessText.style.display = 'inline';
            readLessText.style.opacity = '0';
            setTimeout(() => {
              readLessText.style.opacity = '1';
            }, 10);
          }, 100);
        }
        
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        // Add truncated class to collapse
        content.classList.add('truncated');
        
        // Smooth transition for text change
        if (readMoreText && readLessText) {
          readLessText.style.opacity = '0';
          setTimeout(() => {
            readLessText.style.display = 'none';
            readMoreText.style.display = 'inline';
            readMoreText.style.opacity = '0';
            setTimeout(() => {
              readMoreText.style.opacity = '1';
            }, 10);
          }, 100);
        }
        
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
    
    // Wait for content to be fully rendered
    requestAnimationFrame(() => {
      checkTruncation();
      toggle.addEventListener('click', toggleContent);
    });
  }
  
  // Initialize on DOM ready and when new content is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTruncation);
  } else {
    initializeTruncation();
  }
  
  // Re-initialize when sections are loaded (for dynamic content)
  document.addEventListener('shopify:section:load', () => {
    initializeTruncation();
  });
  } catch(e) { console.error(e); }
})();

})();
